module.exports = {
    post: {
        en: "Post",
        fi: "Ilmoitus"
    },
    forFree: {
        en: "for free",
        fi: "ilmaiseksi"
    },
    noLoginRequired: {
        en: "No login required",
        fi: "Ei sisäänkirjautumista"
    },
    companyInfo: {
        en: "Company Info",
        fi: "Yrityksen tiedot"
    },
    callUs: {
        en: "Call us",
        fi: "Soita meille"
    },
    email: {
        en: "Email",
        fi: "Sähköposti"
    },
    privacyPolicy: {
        en: "Privacy policy",
        fi: "Tietosuojaseloste"
    },
    advice: {
        en: "Advice",
        fi: "Ohjeita"
    }
}